import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://95372bc36792415c930102ba2d6b3f90@o315385.ingest.us.sentry.io/4504965855117312",
  debug: false,
  environment: "production",
  release: "26-0388-try-nova-tears-for-30-days@750cffcb902aa80a026588286e06bdd93b7c788c",
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
});